/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAgentPaymentStatusRequest as AgentApiContractSetAgentPaymentStatusRequest } from '../../models/AgentApi/Contract/set-agent-payment-status-request';

export interface ApiAgentSetAgentPaymentStatusPost$Params {

/**
 * Interface language
 */
  lang?: string;
      body?: Array<AgentApiContractSetAgentPaymentStatusRequest>
}

export function apiAgentSetAgentPaymentStatusPost(http: HttpClient, rootUrl: string, params?: ApiAgentSetAgentPaymentStatusPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAgentSetAgentPaymentStatusPost.PATH, 'post');
  if (params) {
    rb.query('lang', params.lang, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

apiAgentSetAgentPaymentStatusPost.PATH = '/api/Agent/SetAgentPaymentStatus';
